export const DEV_BASE_URL =  "http://localhost:8081"
// export const BASE_URL = "http://localhost:8081";
export const BASE_URL = "https://vote-backend-one.vercel.app";
// export const DEV_BASE_URL = 'https://vote-backend-one.vercel.app'
